/**
 * all states from store
 */
export default {
  available_banners: [],
  selected_banners: [],
  lp_products: [],
};
